import className from "classnames";
import { useEffect } from "react";
import {
  GOVGR_LAYOUT_WRAPPER,
  GOVGR_LAYOUT_WRAPPER__FULL_HEIGHT,
  GOVGR_MODAL,
  GOVGR_MODAL__ACTION,
  GOVGR_MODAL__BODY,
  GOVGR_MODAL__CONTENT,
  GOVGR_MODAL__HEADING,
  GOVGR_MODAL__OPEN,
  GOVGR_MODAL__TEXT,
} from "../../conf/styles/GovGrModal";
import GovGrButton from "../GovGrButton";
import GovGrLink from "../GovGrLink";
import {
  PRIMARY_BUTTON_TEXT,
  SAMPLE_TEXT,
  SECONDARY_BUTTON_TEXT,
  TITLE,
} from "./modalConstants";

const GovGrModal = ({
  open,
  onClose,
  heading = TITLE,
  customContent = false,
  primaryButtonProps = {
    buttonText: PRIMARY_BUTTON_TEXT,
    buttonAction: null,
    disabled: false,
  },
  secondaryButtonProps = {
    buttonText: SECONDARY_BUTTON_TEXT,
    buttonAction: null,
    disabled: false,
  },
  textMessage = SAMPLE_TEXT,
  ...props
}) => {
  let ComponentWrapperClass = className(
    GOVGR_LAYOUT_WRAPPER,
    GOVGR_LAYOUT_WRAPPER__FULL_HEIGHT
  );
  let ModalWrapperClass = className(GOVGR_MODAL, "overflow-hidden", {
    [GOVGR_MODAL__OPEN]: open,
  });

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [open]);
  return (
    <div className={ComponentWrapperClass} style={{ position: "absolute" }}>
      <div className={ModalWrapperClass}>
        <div className={GOVGR_MODAL__BODY}>
          <div className={GOVGR_MODAL__CONTENT}>
            {!customContent ? (
              <>
                <div
                  role="heading"
                  aria-level="2"
                  className={GOVGR_MODAL__HEADING}
                >
                  {heading}
                </div>
                <div className={GOVGR_MODAL__TEXT}>{textMessage}</div>
                <div className={GOVGR_MODAL__ACTION}>
                  {primaryButtonProps?.buttonAction && (
                    <GovGrButton
                      disabled={primaryButtonProps?.disabled}
                      onClick={primaryButtonProps?.buttonAction}
                      buttonText={primaryButtonProps?.buttonText}
                    />
                  )}
                  {secondaryButtonProps?.buttonAction && (
                    <GovGrLink
                      text={secondaryButtonProps?.buttonText}
                      disabled={primaryButtonProps?.disabled}
                      onClick={secondaryButtonProps?.buttonAction}
                    />
                  )}
                </div>
              </>
            ) : (
              props?.children
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GovGrModal;
